import SendArrowSvg from 'util/svg/SendArrowSvg';
import React, {useEffect, useState} from 'react';
import {useSessionConfiguration} from 'util/SessionConfigurationContext';

const AddMoneySendArrow = ({isLegitAmount, handleSubmit, isSending, isInChat = false}) => {
    const {isTouch} = useSessionConfiguration();
    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        setIsHovering(false);
    }, [isLegitAmount]);

    const mouseEntered = () => {
        if (!isTouch && isLegitAmount) {
            console.log('mouseEntered');
            setIsHovering(true);
        }
    };

    const mouseLeft = () => {
        setIsHovering(false);
    };


    return (
        <div
            data-testid="add-money-submit"
            onClick={(event) => {
                event.preventDefault();
                handleSubmit();
            }}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderTopRightRadius: '15px',
                borderBottomRightRadius: '15px',
                borderLeft: (isInChat ? '' : '1px solid gray'),
                fontWeight: 'bold',
                color: '#447337',
                cursor: (isLegitAmount && !isSending) ? 'pointer' : 'default',
            }}
            onMouseEnter={mouseEntered}
            onMouseLeave={mouseLeft}
        >
            <div style={{
                display: 'flex',
                transition: 'transform 2s',
                transform: isSending ? 'translateX(800px)' : (isHovering ? 'translateX(8px)' : 'translateX(0)'),
            }}>
                <SendArrowSvg color={isLegitAmount ? '#447337' : 'gray'} size={isInChat ? 48 : 35}/>
            </div>
        </div>
    );
};

export default AddMoneySendArrow;